import { BrowserRouter } from 'react-router-dom';
import './../src/styles/styles.css';
import Footer from './components/Footer';
import { AuthProvider } from './context/AuthContext';
import { usePageTitle } from './hooks';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PageTitleManager />
        <div className='app-shell'>
          <main className='app-shell__content'>
            <div className='app-shell__page'>
              <AppRoutes />
            </div>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

// Componente interno para manejar títulos de página
function PageTitleManager() {
  usePageTitle();
  return null;
}

export default App;
